import { cacheTypes, getMethodByCallBack, postMethodByCallBack } from "./CommonFunctions";

export function addEditContact(data, onAddEdit) {
    postMethodByCallBack("api/ContactsAPI/AddEditContact", data, onAddEdit, "AddEditContact");
}
export function deleteContact(id, onDelete) {
    getMethodByCallBack(`api/ContactsAPI/DeleteContact?id=${id}`, cacheTypes.NoCache, onDelete, "DeleteContact");
}
export function searchContacts(data, onSearchDone) {
    postMethodByCallBack(`api/ContactsAPI/SearchContacts?name=${data.Name??""}&phone=${data.Phone??""}&mobile=${data.Mobile??""}`, data.GroupID, onSearchDone, "SearchContacts");
}
export function getContactGroupList(onGet) {
    getMethodByCallBack("api/ContactsAPI/GetContactGroupList", cacheTypes.NoCache, onGet, "GetContactGroupList");
}
export function editContactGroupName(id, name, onEdit) {
    getMethodByCallBack(`api/ContactsAPI/EditContactGroupNameid=${id}&name=${name}`, cacheTypes.NoCache, onEdit, "EditContactGroupName");
}
export function deleteContactGroup(id, onDelete) {
    getMethodByCallBack(`api/ContactsAPI/DeleteContactGroup?id=${id}`, cacheTypes.NoCache, onDelete, "DeleteContactGroup");
}